import { connect } from 'react-redux'
import { compose, branch, renderNothing } from 'recompose'
import { any } from 'ismobilejs'

import * as selectors from 'modules/routing/selectors'

import SetupProgress from './component'

const mapStateToProps = (state) => ({
  percentage: selectors.getPercentage(state),
})

export default compose(
  connect(mapStateToProps),
  branch(() => any, renderNothing),
)(SetupProgress)
